import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { BootstrapVueIcons } from "bootstrap-vue"
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import VueSweetalert2 from "vue-sweetalert2"
import "sweetalert2/dist/sweetalert2.min.css"
import Notifications from 'vue-notification'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faPhotoVideo, faBook, faTrash, faEnvelope} from '@fortawesome/free-solid-svg-icons'
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { VueReCaptcha } from 'vue-recaptcha-v3'



library.add(faHome, faPhotoVideo, faBook, faTrash)
library.add(faTelegramPlane)
library.add(faEnvelope)

Vue.use(VueReCaptcha, { 
  siteKey: '6Ldps64ZAAAAAIQNUfrj90xsekX3Aq-OaefJRP12',
  loaderOptions: {
    useRecaptchaNet: true
  }
})
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueViewer)
Vue.use(Notifications)
Vue.use(VueSweetalert2)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.component('icon', Icon)
Vue.config.productionTip = false

import IdleVue from 'idle-vue'
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 10000
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
